module.exports = __webpack_public_path__ + "img/report_active.66b43a58.png";